// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

const accountUrl = "/api/str/account";

export interface AccountSummaryApiParameter extends ApiParameter {
    customerSequence?: string;
    year?: string;
    month?: string;
}

export interface AccountSummaryModel {
    terms: string;
    creditLimit: string;
    total: string;
    lastPurchase: string;
    lastPayment: string;
    mtdPurchases: string;
    ytdPurchases: string;
    paymentDays: string;
    future: string;
    current: string;
    days31To60: string;
    days61To90: string;
    days91To120: string;
    daysOver120: string;
    years: number[];
    customerName: string;
    currentBalance: string;
    availableCredit: string;
    userHasFinancialPermission?: boolean;
    haveOpenOrders?: boolean;
    haveOpenInvoices?: boolean;
    isAdmin?: boolean;
    isBuyer3?: boolean;
    havePendingApprovalItems?: boolean;
    numberOfOpenOrders: string;
    numberOfOpenInvoices: string;
    numberOfPendingApprovalItems: string;
}

export async function getAccountSummary(data: AccountSummaryApiParameter): Promise<AccountSummaryModel> {
    const accountSummary = await get<AccountSummaryModel>(`${accountUrl}/GetAccountInfo`, data);
    return accountSummary;
}

export async function getAccountSummaryDashboard(): Promise<AccountSummaryModel> {
    const accountSummary = await get<AccountSummaryModel>(`${accountUrl}/PopulateAccountSummaryInDashboard`);
    return accountSummary;
}
